import { render, staticRenderFns } from "./ModalCreateUser.vue?vue&type=template&id=5e0e5a37&"
import script from "./ModalCreateUser.vue?vue&type=script&lang=ts&"
export * from "./ModalCreateUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports